enum CCorpSuffixes {
  Association = 'Association',
  Company = 'Company',
  Co = 'Co.',
  Corporation = 'Corporation',
  Corp = 'Corp.',
  Club = 'Club',
  Foundation = 'Foundation',
  Fund = 'Fund',
  Incorporated = 'Incorporated',
  Inc = 'Inc.',
  Institute = 'Institute',
  Limited = 'Limited',
  Ltd = 'Ltd.',
  Society = 'Society',
  Syndicate = 'Syndicate',
  Union = 'Union',
}

const allCCorpSuffixValues = Object.values(CCorpSuffixes);

/** Keyed by the content's jurisdiction id. A state absent here allows every suffix. */
export const jurisdictionToSuffixMap: Record<string, CCorpSuffixes[]> = {
  'ADM1_US-TX': [
    CCorpSuffixes.Corp,
    CCorpSuffixes.Corporation,
    CCorpSuffixes.Incorporated,
    CCorpSuffixes.Inc,
    CCorpSuffixes.Company,
    CCorpSuffixes.Co,
    CCorpSuffixes.Limited,
    CCorpSuffixes.Ltd,
  ],
  'ADM1_US-WY': [
    CCorpSuffixes.Corporation,
    CCorpSuffixes.Corp,
    CCorpSuffixes.Inc,
    CCorpSuffixes.Incorporated,
    CCorpSuffixes.Company,
    CCorpSuffixes.Co,
  ],
  'ADM1_US-DE': allCCorpSuffixValues,
};

export { YesNoNotSureOptions } from '@commenda/types/src/common/enums';
